import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero">
      {/* Background gradient */}
      <div className="hero-bg" />

      {/* Animated grid pattern */}
      <div className="hero-grid" />

      {/* Glow effect */}
      <div className="hero-glow" />

      <div className="hero-container">
        <div className="hero-inner">
          {/* Badge */}
          <div className="hero-badge">
            <Sparkles className="icon-16" />
            <span>AI-Powered Consulting for Modern Businesses</span>
          </div>

          {/* Headline */}
          <h1 className="hero-title">
            We Help Businesses{" "}
            <span className="hero-gradient-text">Automate, Innovate, and Grow</span>{" "}
            with AI
          </h1>

          {/* Subheadline */}
          <p className="hero-subtitle">
            InnoRock helps small and mid-sized companies identify where AI can make the biggest
            impact — and builds practical solutions to make it happen.
          </p>

          {/* CTA Buttons */}
          <div className="hero-ctas">
            <a href="#contact" className="btn btn-primary">
              Book Free AI Audit
              <ArrowRight className="icon-20 ml-8" />
            </a>
            <a href="#services" className="btn btn-outline">
              See How It Works
            </a>
          </div>

          {/* Trust indicators */}
          <div className="hero-trust">
            <div className="trust-item"><span className="dot" /> AI Strategy</div>
            <div className="trust-item"><span className="dot" /> Automation</div>
            <div className="trust-item"><span className="dot" /> Integration</div>
            <div className="trust-item"><span className="dot" /> Training</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
export { Hero };
